import { useState, useCallback } from "react";
import cloudApi from "../../../services/cloudApi";

/**
 * Hook for deleting rows in cloud mode with optimistic updates: the row
 * disappears immediately, the API call runs behind it, and a failed call
 * restores the server state via refreshData.
 */
export const useCloudRowDeletion = ({ tableId, removeRowsLocal, refreshData }) => {
  const [deletingRowId, setDeletingRowId] = useState(null);
  const [rowDeleteFeedback, setRowDeleteFeedback] = useState(null);

  const handleRowDelete = useCallback(
    async (rowId) => {
      if (!tableId || !rowId || deletingRowId) return;

      setDeletingRowId(rowId);

      // Optimistic update - remove row immediately
      removeRowsLocal([rowId]);

      try {
        await cloudApi.deleteRows(tableId, [rowId]);
        setRowDeleteFeedback("Row deleted");
      } catch (error) {
        // Restore server state on error
        console.error("Failed to delete row:", error);
        await refreshData();
        alert("Failed to delete row. Please try again.");
      } finally {
        setDeletingRowId(null);
      }
    },
    [tableId, deletingRowId, removeRowsLocal, refreshData]
  );

  const clearRowDeleteFeedback = useCallback(() => {
    setRowDeleteFeedback(null);
  }, []);

  return {
    deletingRowId,
    handleRowDelete,
    rowDeleteFeedback,
    clearRowDeleteFeedback,
  };
};

export default useCloudRowDeletion;
